
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'LoadingModal',
    props: {
        isFullScreen: Boolean,
    },
});
